import PropTypes from 'prop-types';
// material
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ListItemText from '@mui/material/ListItemText';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
// components
import ItemVoucherStatus from './ItemVoucherStatus';

const RootStyle = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  paddingTop: theme.spacing(1),
  borderTop: `1px dashed ${grey[300]}`
}));

ItemVoucher.propTypes = {
  item: PropTypes.object
};

export default function ItemVoucher({ item }) {
  return (
    <RootStyle display="flex" alignItems="center">
      <Box mr={2} flexGrow={1}>
        <ListItemText
          primary={
            <>
              <Typography component="span" color="textSecondary">
                {item.ticket.voucher.code}
              </Typography>
            </>
          }
        />
      </Box>
      <ItemVoucherStatus item={item} />
    </RootStyle>
  );
}
